// import {
//     Box,
//     Button,
//     CircularProgress,
//     Paper,
//     Slide,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow
// } from "@mui/material";
// import { TransitionProps } from "@mui/material/transitions";
// import React, { useEffect, useState } from "react";
// import { fetchStoreInventory } from "../../services/inventoryService";

// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<unknown>;
//   },
//   ref: React.Ref<unknown>
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// const StoreInventory: React.FC = () => {
//   const [inventory, setInventory] = useState<any[]>([]); // Type it properly based on your data
//   const [loading, setLoading] = useState<boolean>(true);
//   // Fetch inventory data when the component mounts
//   useEffect(() => {
//     const getInventoryData = async () => {
//       try {
//         const data = await fetchStoreInventory(); // Fetch the inventory data from an API
//         setInventory(data);
//       } catch (error) {
//         console.error("Error fetching inventory:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getInventoryData();
//   }, []);

//   // Handle clicking on a row (maybe for more details or editing)
//   const handleRowClick = (id: string) => {
//     // navigate(`/inventory/${id}`); // Redirect to a detailed view or edit page for the inventory item
//   };

//   return (
//     <>
//       <Box sx={{ padding: 1 }}>
//         {loading ? (
//           <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
//         ) : (
//           <TableContainer component={Paper} sx={{ height: "85vh" }}>
//             <Table
//               sx={{ minWidth: 650 }}
//               aria-label="simple table"
//               stickyHeader
//             >
//               <TableHead className="table-header">
//                 <TableRow sx={{ border: "1px solid #132A13" }}>
//                     <TableCell sx={{ backgroundColor: "#d2d7f5ff" }} align="right">
//                     No
//                   </TableCell>
//                   <TableCell sx={{ backgroundColor: "#d2d7f5ff" }}>
//                     Item Name
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Description
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Pack
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Quantity
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Price
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Category
//                   </TableCell>
//                   <TableCell
//                     sx={{ backgroundColor: "#d2d7f5ff" }}
//                     align="right"
//                   >
//                     Action
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {inventory.map((item: any, index) => (
//                   <TableRow
//                     key={item.id}
//                     hover
//                     onClick={() => handleRowClick(item.id)}
//                     sx={{ cursor: "pointer" }}
//                   >
//                     <TableCell align="right">{index + 1}</TableCell>
//                     <TableCell component="th" scope="row">
//                       {item.product_name}
//                     </TableCell>
//                     <TableCell align="right">{item.description}</TableCell>
//                     <TableCell align="right">
//                       {item.packed} {item.unit}
//                     </TableCell>
//                     <TableCell align="right">{item.qty_packed}</TableCell>
//                     <TableCell align="right">${item.cost}</TableCell>
//                     <TableCell align="right">{item.category}</TableCell>
//                     <TableCell align="right">
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         onClick={() => handleRowClick(item.id)}
//                       >
//                         View/Edit
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Box>
//     </>
//   );
// };

// export default StoreInventory;

import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, {
  ChangeEvent,
  useCallback,
  useDeferredValue,
  useEffect,
  useMemo,
  useState,
} from "react";
import { fetchStoreInventory } from "../../services/inventoryService";

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------

interface StoreInventoryItem {
  inventory_id: string;
  qty_packed: string;
  qty_unpacked: string;
  created_at: string;
  updated_at: string;
  store_id: string;
  store_name: string;
  address: string;
  city: string;
  postal_code: string;
  manager: string;
  email: string;
  phone: string;
  store_type: string;
  product_id: string;
  product_name: string;
  description: string;
  cost: string;
  msrp: string;
  category: string;
  sub_category: string;
  packed: string;
  product_type: string | null;
  unit: string;
  product_created_at: string;
  product_updated_at: string;
}

interface InventorySubCategoryGroup {
  name: string;
  products: StoreInventoryItem[];
  productCount: number;
  totalPackedQuantity: number;
}

interface InventoryCategoryGroup {
  name: string;
  subCategories: InventorySubCategoryGroup[];
  productCount: number;
  totalPackedQuantity: number;
  totalInventoryValue: number;
}

interface InventorySummary {
  productCount: number;
  categoryCount: number;
  totalPackedQuantity: number;
  totalInventoryValue: number;
}

interface SummaryCardProps {
  label: string;
  value: string;
  description: string;
}

interface InventoryProductCardProps {
  item: StoreInventoryItem;
  onView: (inventoryId: string) => void;
}

// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

const UNKNOWN_CATEGORY = "Uncategorized";
const UNKNOWN_SUB_CATEGORY = "Other";
const PRODUCTS_PER_BATCH = 24;

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat("en-US");

// -----------------------------------------------------------------------------
// Utility functions
// -----------------------------------------------------------------------------

/**
 * Converts API string values into safe numbers.
 */
const toNumber = (value: string | number | null | undefined): number => {
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

/**
 * Returns a cleaned group name or the provided fallback.
 */
const normalizeGroupName = (
  value: string | null | undefined,
  fallback: string,
): string => {
  return value?.trim() || fallback;
};

/**
 * Returns the first available character for the product avatar.
 */
const getProductInitial = (productName: string): string => {
  return productName.trim().charAt(0).toUpperCase() || "P";
};

/**
 * Creates the searchable lowercase value once per filter operation.
 */
const getSearchableText = (item: StoreInventoryItem): string => {
  return [
    item.product_name,
    item.description,
    item.category,
    item.sub_category,
    item.store_name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};

// -----------------------------------------------------------------------------
// Summary card
// -----------------------------------------------------------------------------

const SummaryCard: React.FC<SummaryCardProps> = React.memo(
  ({ label, value, description }) => {
    return (
      <Paper
        variant="outlined"
        sx={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          borderRadius: 3,
          p: {
            xs: 1.5,
            sm: 2,
          },
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 600 }}
        >
          {label}
        </Typography>

        <Typography
          variant="h5"
          sx={{
            mt: 0.75,
            minWidth: 0,
            fontWeight: 750,
            lineHeight: 1.2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value}
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: "block",
            mt: 0.75,
          }}
        >
          {description}
        </Typography>
      </Paper>
    );
  },
);

SummaryCard.displayName = "SummaryCard";

// -----------------------------------------------------------------------------
// Product card
// -----------------------------------------------------------------------------

const InventoryProductCard: React.FC<InventoryProductCardProps> = React.memo(
  ({ item, onView }) => {
    const packedQuantity = toNumber(item.qty_packed);
    const unpackedQuantity = toNumber(item.qty_unpacked);

    /**
     * Opens the selected inventory record.
     */
    const handleView = () => {
      onView(item.inventory_id);
    };

    return (
      <Card
        variant="outlined"
        onClick={handleView}
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          height: "100%",
          boxSizing: "border-box",
          borderRadius: 3,
          cursor: "pointer",
          overflow: "hidden",
          transition:
            "transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease",
          "&:hover": {
            transform: "translateY(-2px)",
            borderColor: "primary.main",
            boxShadow: 2,
          },
        }}
      >
        <Box sx={{ p: 1.5 }}>
          <Stack
            direction="row"
            spacing={1.25}
            alignItems="flex-start"
            sx={{
              width: "100%",
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                flexShrink: 0,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "primary.main",
                color: "primary.contrastText",
                fontWeight: 750,
              }}
            >
              {getProductInitial(item.product_name)}
            </Box>

            <Box
              sx={{
                flex: 1,
                minWidth: 0,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  minWidth: 0,
                  fontWeight: 750,
                  lineHeight: 1.3,
                  overflowWrap: "anywhere",
                }}
              >
                {item.product_name}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: "-webkit-box",
                  mt: 0.35,
                  overflow: "hidden",
                  overflowWrap: "anywhere",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                }}
              >
                {item.description || "No description available"}
              </Typography>
            </Box>

            <Chip
              label={numberFormatter.format(packedQuantity)}
              size="small"
              color={packedQuantity > 0 ? "success" : "default"}
              sx={{
                maxWidth: 90,
                flexShrink: 0,
                fontWeight: 700,
                "& .MuiChip-label": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
            />
          </Stack>

          <Divider sx={{ my: 1.5 }} />

          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 1,
            }}
          >
            <Box
              sx={{
                minWidth: 0,
                p: 1,
                borderRadius: 2,
                bgcolor: "action.hover",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Pack size
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.2,
                  fontWeight: 700,
                  overflowWrap: "anywhere",
                }}
              >
                {item.packed} {item.unit}
              </Typography>
            </Box>

            <Box
              sx={{
                minWidth: 0,
                p: 1,
                borderRadius: 2,
                bgcolor: "action.hover",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Cost
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.2,
                  fontWeight: 700,
                  overflowWrap: "anywhere",
                }}
              >
                {currencyFormatter.format(toNumber(item.cost))}
              </Typography>
            </Box>

            <Box
              sx={{
                minWidth: 0,
                p: 1,
                borderRadius: 2,
                bgcolor: "action.hover",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Packed
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.2,
                  fontWeight: 700,
                }}
              >
                {numberFormatter.format(packedQuantity)}
              </Typography>
            </Box>

            <Box
              sx={{
                minWidth: 0,
                p: 1,
                borderRadius: 2,
                bgcolor: "action.hover",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Unpacked
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.2,
                  fontWeight: 700,
                }}
              >
                {numberFormatter.format(unpackedQuantity)}
              </Typography>
            </Box>
          </Box>

          <Button
            fullWidth
            size="small"
            variant="outlined"
            onClick={(event) => {
              event.stopPropagation();
              handleView();
            }}
            sx={{
              mt: 1.5,
              minHeight: 38,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            View inventory
          </Button>
        </Box>
      </Card>
    );
  },
);

InventoryProductCard.displayName = "InventoryProductCard";

// -----------------------------------------------------------------------------
// Main component
// -----------------------------------------------------------------------------

const StoreInventory: React.FC = () => {
  const [inventory, setInventory] = useState<StoreInventoryItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");

  const [expandedCategory, setExpandedCategory] = useState<string | false>(
    false,
  );

  const [selectedSubCategories, setSelectedSubCategories] = useState<
    Record<string, string>
  >({});

  const [visibleProductCounts, setVisibleProductCounts] = useState<
    Record<string, number>
  >({});

  const deferredSearchTerm = useDeferredValue(searchTerm);

  /**
   * Loads inventory once when the component mounts.
   */
  useEffect(() => {
    let isMounted = true;

    const loadInventory = async () => {
      try {
        setLoading(true);
        setErrorMessage("");

        const response = await fetchStoreInventory();
        const inventoryData = Array.isArray(response) ? response : [];

        if (isMounted) {
          setInventory(inventoryData as StoreInventoryItem[]);
        }
      } catch (error) {
        console.error("Error fetching store inventory:", error);

        if (isMounted) {
          setErrorMessage(
            "Inventory could not be loaded. Please refresh the page and try again.",
          );
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadInventory();

    return () => {
      isMounted = false;
    };
  }, []);

  /**
   * Filters inventory with a deferred search value to keep typing responsive.
   */
  const filteredInventory = useMemo(() => {
    const normalizedSearch = deferredSearchTerm.trim().toLowerCase();

    if (!normalizedSearch) {
      return inventory;
    }

    return inventory.filter((item) =>
      getSearchableText(item).includes(normalizedSearch),
    );
  }, [inventory, deferredSearchTerm]);

  /**
   * Groups filtered inventory in one pass.
   */
  const groupedInventory = useMemo<InventoryCategoryGroup[]>(() => {
    const categoryMap = new Map<
      string,
      {
        productCount: number;
        totalPackedQuantity: number;
        totalInventoryValue: number;
        subCategories: Map<
          string,
          {
            products: StoreInventoryItem[];
            totalPackedQuantity: number;
          }
        >;
      }
    >();

    filteredInventory.forEach((item) => {
      const categoryName = normalizeGroupName(item.category, UNKNOWN_CATEGORY);

      const subCategoryName = normalizeGroupName(
        item.sub_category,
        UNKNOWN_SUB_CATEGORY,
      );

      const packedQuantity = toNumber(item.qty_packed);
      const productCost = toNumber(item.cost);

      let categoryGroup = categoryMap.get(categoryName);

      if (!categoryGroup) {
        categoryGroup = {
          productCount: 0,
          totalPackedQuantity: 0,
          totalInventoryValue: 0,
          subCategories: new Map(),
        };

        categoryMap.set(categoryName, categoryGroup);
      }

      categoryGroup.productCount += 1;
      categoryGroup.totalPackedQuantity += packedQuantity;
      categoryGroup.totalInventoryValue += packedQuantity * productCost;

      let subCategoryGroup = categoryGroup.subCategories.get(subCategoryName);

      if (!subCategoryGroup) {
        subCategoryGroup = {
          products: [],
          totalPackedQuantity: 0,
        };

        categoryGroup.subCategories.set(subCategoryName, subCategoryGroup);
      }

      subCategoryGroup.products.push(item);
      subCategoryGroup.totalPackedQuantity += packedQuantity;
    });

    return Array.from(categoryMap.entries())
      .map(([categoryName, categoryGroup]) => {
        const subCategories = Array.from(categoryGroup.subCategories.entries())
          .map(([subCategoryName, subCategoryGroup]) => ({
            name: subCategoryName,
            products: subCategoryGroup.products.sort((first, second) =>
              first.product_name.localeCompare(second.product_name),
            ),
            productCount: subCategoryGroup.products.length,
            totalPackedQuantity: subCategoryGroup.totalPackedQuantity,
          }))
          .sort((first, second) => first.name.localeCompare(second.name));

        return {
          name: categoryName,
          subCategories,
          productCount: categoryGroup.productCount,
          totalPackedQuantity: categoryGroup.totalPackedQuantity,
          totalInventoryValue: categoryGroup.totalInventoryValue,
        };
      })
      .sort((first, second) => first.name.localeCompare(second.name));
  }, [filteredInventory]);

  /**
   * Calculates overall inventory totals in one pass.
   */
  const inventorySummary = useMemo<InventorySummary>(() => {
    const categoryNames = new Set<string>();

    return inventory.reduce<InventorySummary>(
      (summary, item) => {
        const categoryName = normalizeGroupName(
          item.category,
          UNKNOWN_CATEGORY,
        );

        categoryNames.add(categoryName);

        const packedQuantity = toNumber(item.qty_packed);

        summary.productCount += 1;
        summary.totalPackedQuantity += packedQuantity;
        summary.totalInventoryValue += packedQuantity * toNumber(item.cost);
        summary.categoryCount = categoryNames.size;

        return summary;
      },
      {
        productCount: 0,
        categoryCount: 0,
        totalPackedQuantity: 0,
        totalInventoryValue: 0,
      },
    );
  }, [inventory]);

  /**
   * Updates the search term.
   */
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setExpandedCategory(false);
  };

  /**
   * Clears the current search.
   */
  const handleClearSearch = () => {
    setSearchTerm("");
    setExpandedCategory(false);
  };

  /**
   * Opens or closes a category.
   */
  const handleCategoryChange =
    (category: InventoryCategoryGroup) =>
    (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedCategory(isExpanded ? category.name : false);

      if (
        isExpanded &&
        !selectedSubCategories[category.name] &&
        category.subCategories.length > 0
      ) {
        setSelectedSubCategories((current) => ({
          ...current,
          [category.name]: category.subCategories[0].name,
        }));
      }
    };

  /**
   * Selects a subcategory inside the current category.
   */
  const handleSubCategorySelect = (
    categoryName: string,
    subCategoryName: string,
  ) => {
    setSelectedSubCategories((current) => ({
      ...current,
      [categoryName]: subCategoryName,
    }));

    setVisibleProductCounts((current) => ({
      ...current,
      [`${categoryName}-${subCategoryName}`]: PRODUCTS_PER_BATCH,
    }));
  };

  /**
   * Shows the next batch of products for the selected subcategory.
   */
  const handleLoadMore = (categoryName: string, subCategoryName: string) => {
    const groupKey = `${categoryName}-${subCategoryName}`;

    setVisibleProductCounts((current) => ({
      ...current,
      [groupKey]:
        (current[groupKey] || PRODUCTS_PER_BATCH) + PRODUCTS_PER_BATCH,
    }));
  };

  /**
   * Opens the selected inventory record.
   */
  const handleViewInventory = useCallback((inventoryId: string) => {
    console.log("Selected inventory:", inventoryId);

    // Navigate when the details route is available.
    // navigate(`/inventory/${inventoryId}`);
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
          boxSizing: "border-box",
        }}
      >
        <Stack spacing={1.5} alignItems="center">
          <CircularProgress size={40} />

          <Typography variant="body2" color="text.secondary">
            Loading store inventory...
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflowX: "hidden",
        boxSizing: "border-box",
        p: {
          xs: 1,
          sm: 2,
          lg: 3,
        },
      }}
    >
      <Stack
        spacing={2.25}
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        {/* Page heading */}
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1.25}
          alignItems={{
            xs: "flex-start",
            sm: "center",
          }}
          justifyContent="space-between"
          sx={{
            width: "100%",
            minWidth: 0,
          }}
        >
          <Stack
            direction="row"
            spacing={1.25}
            alignItems="center"
            sx={{ minWidth: 0 }}
          >
            <Box
              sx={{
                width: 46,
                height: 46,
                flexShrink: 0,
                borderRadius: 2.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "primary.main",
                color: "primary.contrastText",
              }}
            >
              <Inventory2OutlinedIcon />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  letterSpacing: "-0.02em",
                }}
              >
                Store Inventory
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Browse products by category and subcategory.
              </Typography>
            </Box>
          </Stack>

          <Chip
            label={`${numberFormatter.format(
              filteredInventory.length,
            )} products shown`}
            variant="outlined"
            sx={{
              maxWidth: "100%",
              fontWeight: 650,
            }}
          />
        </Stack>

        {errorMessage && (
          <Alert severity="error" sx={{ borderRadius: 2.5 }}>
            {errorMessage}
          </Alert>
        )}

        {/* Summary */}
        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(4, minmax(0, 1fr))",
            },
            gap: 1.25,
          }}
        >
          <SummaryCard
            label="Products"
            value={numberFormatter.format(inventorySummary.productCount)}
            description="Total inventory records"
          />

          <SummaryCard
            label="Categories"
            value={numberFormatter.format(inventorySummary.categoryCount)}
            description="Product categories"
          />

          <SummaryCard
            label="Packed quantity"
            value={numberFormatter.format(inventorySummary.totalPackedQuantity)}
            description="Across all products"
          />

          <SummaryCard
            label="Inventory value"
            value={currencyFormatter.format(
              inventorySummary.totalInventoryValue,
            )}
            description="Based on current cost"
          />
        </Box>

        {/* Search */}
        <Paper
          variant="outlined"
          sx={{
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            borderRadius: 3,
            p: {
              xs: 1.25,
              sm: 1.5,
            },
          }}
        >
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={1.25}
          >
            <TextField
              fullWidth
              size="small"
              label="Search inventory"
              placeholder="Search product, category, or subcategory"
              value={searchTerm}
              onChange={handleSearchChange}
            />

            <Button
              variant="outlined"
              onClick={handleClearSearch}
              disabled={!searchTerm}
              sx={{
                minHeight: 40,
                px: 2,
                flexShrink: 0,
                borderRadius: 2,
                textTransform: "none",
                whiteSpace: "nowrap",
              }}
            >
              Clear search
            </Button>
          </Stack>
        </Paper>

        {groupedInventory.length === 0 ? (
          <Paper
            variant="outlined"
            sx={{
              width: "100%",
              py: 6,
              px: 2,
              boxSizing: "border-box",
              borderRadius: 3,
              textAlign: "center",
            }}
          >
            <SearchOffRoundedIcon
              sx={{
                fontSize: 46,
                color: "text.disabled",
              }}
            />

            <Typography
              variant="h6"
              sx={{
                mt: 1,
                fontWeight: 750,
              }}
            >
              No inventory found
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Try a different product, category, or subcategory.
            </Typography>

            {searchTerm && (
              <Button
                variant="contained"
                onClick={handleClearSearch}
                sx={{
                  mt: 2,
                  borderRadius: 2,
                  textTransform: "none",
                }}
              >
                Clear search
              </Button>
            )}
          </Paper>
        ) : (
          <Stack
            spacing={1.25}
            sx={{
              width: "100%",
              minWidth: 0,
            }}
          >
            {groupedInventory.map((category) => {
              const selectedSubCategoryName =
                selectedSubCategories[category.name] ||
                category.subCategories[0]?.name;

              const selectedSubCategory = category.subCategories.find(
                (subCategory) => subCategory.name === selectedSubCategoryName,
              );

              const groupKey = `${category.name}-${selectedSubCategoryName}`;

              const visibleCount =
                visibleProductCounts[groupKey] || PRODUCTS_PER_BATCH;

              const visibleProducts =
                selectedSubCategory?.products.slice(0, visibleCount) || [];

              const hasMoreProducts = selectedSubCategory
                ? visibleCount < selectedSubCategory.productCount
                : false;

              return (
                <Accordion
                  key={category.name}
                  expanded={expandedCategory === category.name}
                  onChange={handleCategoryChange(category)}
                  disableGutters
                  elevation={0}
                  TransitionProps={{
                    unmountOnExit: true,
                  }}
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    minWidth: 0,
                    boxSizing: "border-box",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: "14px !important",
                    overflow: "hidden",
                    "&::before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreRoundedIcon />}
                    sx={{
                      width: "100%",
                      minWidth: 0,
                      px: {
                        xs: 1.25,
                        sm: 2,
                      },
                      "& .MuiAccordionSummary-content": {
                        width: "100%",
                        minWidth: 0,
                        overflow: "hidden",
                      },
                    }}
                  >
                    <Stack
                      direction={{
                        xs: "column",
                        md: "row",
                      }}
                      spacing={1}
                      alignItems={{
                        xs: "flex-start",
                        md: "center",
                      }}
                      justifyContent="space-between"
                      sx={{
                        width: "100%",
                        minWidth: 0,
                        pr: 1,
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={1.25}
                        alignItems="center"
                        sx={{ minWidth: 0 }}
                      >
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            flexShrink: 0,
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "primary.main",
                            color: "primary.contrastText",
                            fontWeight: 800,
                          }}
                        >
                          {category.name.charAt(0).toUpperCase()}
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: 800,
                              overflowWrap: "anywhere",
                            }}
                          >
                            {category.name}
                          </Typography>

                          <Typography variant="caption" color="text.secondary">
                            {category.subCategories.length} subcategories
                          </Typography>
                        </Box>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.75}
                        useFlexGap
                        flexWrap="wrap"
                        sx={{
                          width: {
                            xs: "100%",
                            md: "auto",
                          },
                          minWidth: 0,
                        }}
                      >
                        <Chip
                          label={`${category.productCount} products`}
                          size="small"
                          variant="outlined"
                        />

                        <Chip
                          label={`${numberFormatter.format(
                            category.totalPackedQuantity,
                          )} quantity`}
                          size="small"
                          color="success"
                          variant="outlined"
                        />

                        <Chip
                          label={currencyFormatter.format(
                            category.totalInventoryValue,
                          )}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </Stack>
                    </Stack>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      width: "100%",
                      minWidth: 0,
                      boxSizing: "border-box",
                      bgcolor: "grey.50",
                      p: {
                        xs: 1,
                        sm: 1.5,
                      },
                    }}
                  >
                    {/* Subcategory selector */}
                    <Stack
                      direction="row"
                      spacing={0.75}
                      useFlexGap
                      flexWrap="wrap"
                      sx={{
                        width: "100%",
                        minWidth: 0,
                        mb: 1.5,
                      }}
                    >
                      {category.subCategories.map((subCategory) => {
                        const isSelected =
                          selectedSubCategoryName === subCategory.name;

                        return (
                          <Button
                            key={subCategory.name}
                            size="small"
                            variant={isSelected ? "contained" : "outlined"}
                            onClick={() =>
                              handleSubCategorySelect(
                                category.name,
                                subCategory.name,
                              )
                            }
                            sx={{
                              maxWidth: "100%",
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 650,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {subCategory.name} ({subCategory.productCount})
                          </Button>
                        );
                      })}
                    </Stack>

                    {selectedSubCategory && (
                      <>
                        <Paper
                          variant="outlined"
                          sx={{
                            width: "100%",
                            minWidth: 0,
                            mb: 1.25,
                            p: 1.25,
                            boxSizing: "border-box",
                            borderRadius: 2.5,
                          }}
                        >
                          <Stack
                            direction={{
                              xs: "column",
                              sm: "row",
                            }}
                            spacing={0.75}
                            alignItems={{
                              xs: "flex-start",
                              sm: "center",
                            }}
                            justifyContent="space-between"
                          >
                            <Box sx={{ minWidth: 0 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 750,
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {selectedSubCategory.name}
                              </Typography>

                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {selectedSubCategory.productCount} products
                              </Typography>
                            </Box>

                            <Chip
                              label={`${numberFormatter.format(
                                selectedSubCategory.totalPackedQuantity,
                              )} quantity`}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          </Stack>
                        </Paper>

                        {/* Only the selected subcategory is rendered */}
                        <Box
                          sx={{
                            width: "100%",
                            minWidth: 0,
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
                            gap: 1.25,
                          }}
                        >
                          {visibleProducts.map((item) => (
                            <InventoryProductCard
                              key={item.inventory_id}
                              item={item}
                              onView={handleViewInventory}
                            />
                          ))}
                        </Box>

                        {hasMoreProducts && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mt: 1.5,
                            }}
                          >
                            <Button
                              variant="outlined"
                              onClick={() =>
                                handleLoadMore(
                                  category.name,
                                  selectedSubCategory.name,
                                )
                              }
                              sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 700,
                              }}
                            >
                              Load more products
                            </Button>
                          </Box>
                        )}
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default StoreInventory;
